import { DateTime } from "luxon";
import store from '@/store/index.js'

export function date(value) {
  if (!value) {
    return "";
  }

  const locale = store.getters['device/language'];
  // { locale } is expected to be ["es-ES", "en-US"]
  return DateTime.fromISO(value, { locale }).toLocaleString(DateTime.DATE_HUGE);
}

export function shortDate(value) {
  if (!value) {
    return "";
  }

  const locale = store.getters['device/language'];
  return DateTime
    .fromISO(value)
    .setLocale(locale)
    .toFormat('ccc d LLL');
}

export function mediumDate(value) {
  if (!value) {
    return "";
  }

  const locale = store.getters['device/language'];
  return DateTime
    .fromISO(value)
    .setLocale(locale)
    .toLocaleString({weekday: 'long', day: '2-digit', month: 'short'})
}

export function longDate(value) {
  if (!value) {
    return "";
  }

  const locale = store.getters['device/language'];
  return DateTime
    .fromISO(value)
    .setLocale(locale)
    .toLocaleString(DateTime.DATE_HUGE)
}
